import { ViewListIcon } from '@heroicons/react/solid';

import InfinitePractice from '../../Components/InfinitePractice';

const infinitePractice = {
  title: 'Práctica Infinita', // Display name of the tool
  category: 'Estudio',
  to: '/api/v1/infinite_practice',
  api: '/api/v1/infinite_practice',
  legacyTo: '/auto/infinite-practice',
  legacyApi: '/ai/auto/infinite-practice',
  Icon: ViewListIcon, // Define your icon component or import it
  desc: 'Optimiza tu aprendizaje con técnicas basadas en la ciencia: repetición espaciada y recuperación activa para una retención duradera y eficiente del conocimiento.',
  fromColor: 'yellow-400',
  toColor: 'black',
  component: InfinitePractice, // The React component that implements the tool
};

export default infinitePractice;
